var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "project"
  }, [_c('a', {
    staticClass: "project-link",
    attrs: {
      "href": _vm.project.url
    }
  }, [_vm._v("\n    View Project\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "project-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.project.photos[0].url,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "project-text"
  }, [_c('h1', {
    staticClass: "project-name h5"
  }, [_vm._v(_vm._s(_vm.project.title))]), _vm._v(" "), _c('div', {
    staticClass: "project-company"
  }, [_c('img', {
    staticClass: "project-company-logo",
    attrs: {
      "src": _vm.project.company.logo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "project-company-info"
  }, [_c('h3', {
    staticClass: "project-company-name"
  }, [_vm._v(_vm._s(_vm.project.company.name))]), _vm._v(" "), _c('h3', {
    staticClass: "project-company-location"
  }, [_vm._v(_vm._s(_vm.project.company.location))])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-666b94dc","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/project-card.vue
// module id = null
// module chunks = 